import { alpha, Chip, Stack, type SxProps, Typography } from '@mui/material';
import { CrownIcon } from 'lucide-react';
import { memo, type ReactNode } from 'react';
import { mergeSx } from '@/utils/mergeSx';
import { Icon } from '../Icon/Icon';

type PremiumPillProps = {
  label?: ReactNode;
};

export const PremiumPill = memo(function PremiumPill({ label = 'Premium' }: PremiumPillProps) {
  return (
    <Chip
      variant="outlined"
      color="warning"
      icon={<CrownIcon size={12} />}
      label={label}
      size="small"
      sx={(theme) => ({
        '& .MuiChip-icon': {
          color: theme.palette.warning.dark,
        },
        '& .MuiChip-label': {
          color: theme.palette.warning.dark,
          marginTop: '2px',
        },
        '& .MuiChip-root': {
          border: '1px solid',
        },
        backgroundClip: 'padding-box, border-box',
        backgroundImage: `linear-gradient(${theme.palette.background.default},
      ${alpha(theme.palette.warning._states.hover!, 0.1)}),
      linear-gradient(to right,  ${alpha(theme.palette.warning.dark, 0.06)},
      ${alpha(theme.palette.warning.light, 0.05)})`,

        backgroundOrigin: 'border-box',
        border: '1px solid',
        paddingX: 1,
      })}
    />
  );
});

export const PremiumPillSimple = memo(function PremiumPillSimple({ sx }: { sx?: SxProps }) {
  return (
    <Stack direction="row" sx={mergeSx({ gap: 0.5, alignItems: 'baseline' }, sx)}>
      <Icon icon={CrownIcon} size={12} sx={{ color: 'warning.main' }} />
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
        }}
      >
        Premium
      </Typography>
    </Stack>
  );
});
